/// <reference path="./PayTable/GamePayTable.ts" />
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AppEvent } from "@lib/titan2/dist/game/Constants";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { MouseUtil } from "@lib/titan2/dist/util/view/MouseUtil";
import { GamePayTable } from "./PayTable/GamePayTable";
/**
 * GameMiniPayTable.ts
 */
export class GameMiniPayTable extends GamePayTable {
    create() {
        super.create();
        Logger.addObjectRef(this, "MiniPayTable");
        MouseUtil.setInteractive(this.animation, true);
    }
    setupClickEvents() {
        MouseUtil.addMouseUp(this.animation, this.handleMouseUp, this);
    }
    getPrizeValue(payoutMultiplier) {
        return `${payoutMultiplier}x`;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(AppEvent.IDLE, this.handleIdle);
        this.registerCore(AppEvent.BUSY, this.handleBusy);
    }
    handleBusy() {
        MouseUtil.setInteractive(this.animation, false);
    }
    handleIdle() {
        MouseUtil.setInteractive(this.animation, true);
    }
    handleMouseUp() {
        this.model.dispatchKPI("SLNGO_STATE", "MINI_PAY_TABLE_BUTTON_PRESSED", null);
        this.dispatchGame(SlingoEvent.PAY_TABLE_OPEN);
    }
    handleRotate(event) {
        const data = event?.getCurrentTarget() || {};
        this.visible = this.renderer.isPortrait(data.forceOrientation);
        this.applyProperties();
        this.updateCellOrientation();
    }
}
//# sourceMappingURL=GameMiniPayTable.js.map